import { html as p, LitElement as u } from "lit";
import { property as a, state as v, customElement as m } from "lit/decorators.js";
import { StyledElement as h } from "../styledElement.js";
/*! @pentacode/ui v0.1.0 */
const f = `ptc-ui-balance,
:host {
    --balance-color-negative: var(--red);
    --balance-color-positive: var(--green);

    display: inline-block;
    vertical-align: middle;
}

ptc-ui-balance[sign="-1"],
:host([sign="-1"]) {
    color: var(--balance-color-negative);
}

ptc-ui-balance[sign="1"],
:host([sign="1"]) {
    color: var(--balance-color-positive);
}

ptc-ui-balance[inverted],
:host([inverted]) {
    --balance-color-negative: var(--green);
    --balance-color-positive: var(--red);
}
`;
var d = Object.defineProperty, g = Object.getOwnPropertyDescriptor, n = (e, r, o, s) => {
  for (var i = s > 1 ? void 0 : s ? g(r, o) : r, l = e.length - 1, c; l >= 0; l--)
    (c = e[l]) && (i = (s ? c(r, o, i) : c(i)) || i);
  return s && i && d(r, o, i), i;
};
let t = class extends h(u) {
  constructor() {
    super(...arguments), this.styles = f, this.value = 0, this.parser = (e) => Intl.NumberFormat(void 0, {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      signDisplay: "never"
    }).format(e), this.inverted = !1, this.iconStyle = "plus-minus", this.sign = 0;
  }
  /** @internal */
  _getSignIcon(e) {
    if (e !== 0)
      return this.iconStyle === "up-down" ? e === -1 ? "i-fa6-solid-arrow-down" : "i-fa6-solid-arrow-up" : e === -1 ? "i-fa6-solid-minus" : "i-fa6-solid-plus";
  }
  willUpdate(e) {
    e.has("parser") && (this._formattedValue = this.parser(Math.abs(this.value))), e.has("value") && (this._formattedValue = this.parser(Math.abs(this.value)), this.sign = Math.sign(this.value));
  }
  render() {
    const e = this._getSignIcon(this.sign);
    if (!(this.value === null || this.value === void 0))
      return p`
            <div class="ptc-balance inline-flex items-center gap-0.5">
                ${e && p`<i part="sign" class="${this._getSignIcon(this.sign)} font-size-0.75em"></i>`}
                ${this._formattedValue}
                <slot></slot>
            </div>
        `;
  }
};
n([
  a({ type: Number })
], t.prototype, "value", 2);
n([
  a({ attribute: !1 })
], t.prototype, "parser", 2);
n([
  a({ type: Boolean, reflect: !0 })
], t.prototype, "inverted", 2);
n([
  a({ type: String })
], t.prototype, "iconStyle", 2);
n([
  a({ type: Number, reflect: !0 })
], t.prototype, "sign", 2);
n([
  v()
], t.prototype, "_formattedValue", 2);
t = n([
  m("ptc-ui-balance")
], t);
const S = t;
export {
  t as Balance,
  S as default
};
//# sourceMappingURL=balance.js.map
